// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"7a605180","197":"c126d237","430":"814c8299","431":"62c3855a","548":"9e422d94","569":"16cd8b8b","645":"5d54c97d","802":"feb9dde6","852":"582393b6","853":"858c3390"}[chunkId] + ".chunk.js";
};